import React from "react";
import chatVideo from "./assets/chat.webm";

import {
  Box,
  Typography,
} from "@mui/material";

import { NAVY } from "./colors";

export default function ChatPage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f5f7fb",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        px: 2,
        py: 4,
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontWeight: 900,
          color: NAVY,
          mb: 3,
          fontSize: { xs: 24, md: 32 },
          textAlign: "center",
        }}
      >
        Chat Conseiller juridique
      </Typography>

      <Box
        sx={{
          width: "100%",
          maxWidth: "900px",
          borderRadius: 3,
          overflow: "hidden",
          bgcolor: "#000",
          boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
          border: `3px solid ${NAVY}`,
        }}
      >
        <video
          controls
          playsInline
          preload="auto"
          style={{
            width: "100%",
            height: "auto",
            display: "block",
          }}
        >
          <source src={chatVideo} type="video/webm" />
          Votre navigateur ne supporte pas la vidéo HTML5.
        </video>
      </Box>
    </Box>
  );
}
